import { blue, slate, white } from '@/lib/colours';

import { Chip, type ChipProps } from '@/primitives';

export interface ToggleChipProps extends ChipProps {
  toggled?: boolean;
}

export function ToggleChip({ toggled, ...props }: ToggleChipProps) {
  return (
    <Chip
      {...props}
      sx={{
        backgroundColor: toggled ? blue[600] : blue[200],
        color: toggled ? white[900] : slate[900],
        '&:hover': {
          backgroundColor: toggled ? blue[800] : blue[400],
          color: 'white',
        },
      }}
    />
  );
}
